<template>
  <div class="c-app">
    <TheProfileSidebar/>
    <div class="c-wrapper">
      <TheProfileHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheProfileFooter/>
    </div>
  </div>
</template>

<script>
import TheProfileSidebar from './TheProfileSidebar'
import TheProfileHeader from './TheProfileHeader'
import TheProfileFooter from './TheProfileFooter'

export default {
  name: 'TheProfileContainer',
  components: {
    TheProfileSidebar,
    TheProfileHeader,
    TheProfileFooter,
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
